<template>
	<el-container class="detailExamination-box" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">状态</span>
				<el-select
					clearable
					v-model="form.examStatus"
					:placeholder="'请选择'"
				>
					<el-option
						v-for="el in typeList"
						:label="el.label"
						:value="el.value"
						:key="el.value"
					></el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">供应商</span>
				<el-select
					clearable
					v-model="form.likeProvideName"
					:placeholder="'请选择'"
				>
					<el-option
						v-for="el in supplierList"
						:label="el.providerName"
						:value="el.providerName"
						:key="el.id"
					></el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">订单号</span>
				<el-input
					placeholder="订单号"
					class="input-box"
					clearable
					v-model.trim="form.likeOrderNo"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">印刷号</span>
				<el-input
					placeholder="印刷号"
					class="input-box"
					clearable
					v-model.trim="form.likePrintNo"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">预约时间</span>
				<el-date-picker
					format="yyyy-MM-dd"
					v-model="pickerTime.a"
					type="daterange"
					@change="
						(val) =>
							toChangeTime(
								val,
								'bookingStartDate',
								'bookingEndDate'
							)
					"
					range-separator="~"
					start-placeholder="起始日期"
					end-placeholder="截止日期"
					value-format="yyyy-MM-dd"
					:picker-options="{
						disabledDate(time) {
							return time.getTime() > Date.now();
						},
					}"
				>
				</el-date-picker>
			</div>
			<div class="search-item">
				<span class="label">到检时间</span>
				<el-date-picker
					format="yyyy-MM-dd"
					v-model="pickerTime.b"
					type="daterange"
					@change="
						(val) =>
							toChangeTime(val, 'checkStartDate', 'checkEndDate')
					"
					range-separator="~"
					start-placeholder="起始日期"
					end-placeholder="截止日期"
					value-format="yyyy-MM-dd"
					:picker-options="{
						disabledDate(time) {
							return time.getTime() > Date.now();
						},
					}"
				>
				</el-date-picker>
			</div>
			<el-button
				class="search-btn"
				type="primary"
				v-auth="'sa_user_order_page'"
				@click="getData(true)"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
		</div>
		<div class="cont-x">
			<div class="table-x" ref="tableBox">
				<el-table
					v-loading="loading"
					:data="tableData"
					border
					class="mb20"
				>
					<el-table-column
						type="index"
						align="center"
						label="序号"
						width="100"
					>
						<template slot-scope="scope">
							{{
								(page.pageNo - 1) * page.pageSize +
								scope.$index +
								1
							}}
						</template>
					</el-table-column>
					<el-table-column
						prop="orderNo"
						align="center"
						label="订单号"
					>
					</el-table-column>
					<el-table-column
						prop="printNo"
						align="center"
						label="印刷号"
					>
					</el-table-column>
					<el-table-column
						prop="itemName"
						align="center"
						label="服务项目名称"
					>
					</el-table-column>
					<el-table-column
						prop="providerName"
						align="center"
						label="供应商"
					>
					</el-table-column>
					<el-table-column
						prop="examStatus"
						align="center"
						label="状态"
					>
						<template slot-scope="scope">
							<span v-if="scope.row.examStatus != 0">{{
								scope.row.examStatus | typeFilter(typeList)
							}}</span>
							<span v-else>{{
								scope.row.orderStatus
									| typeFilter(orderStatusList)
							}}</span>
						</template>
					</el-table-column>
					<el-table-column
						prop="bookingDate"
						align="center"
						label="预约时间"
					>
						<template slot-scope="scope">
							{{
								scope.row.bookingDate
									? scope.row.bookingDate.substring(0, 10)
									: ""
							}}
						</template>
					</el-table-column>
					<el-table-column
						prop="hospName"
						align="center"
						label="预约网点"
					>
					</el-table-column>
					<el-table-column
						prop="cancelTime"
						align="center"
						label="取消预约时间"
					>
					</el-table-column>
					<el-table-column
						prop="checkDate"
						align="center"
						label="到检时间"
					>
					</el-table-column>
					<el-table-column
						prop="reportTime"
						align="center"
						label="出报告时间"
					>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagenation-x">
			<div class="pagination mb20">
				<el-pagination
					@size-change="getData"
					@current-change="getData"
					:current-page.sync="page.pageNo"
					:page-size.sync="page.pageSize"
					layout="total,  prev, pager, next, jumper"
					:total="page.total"
					background
				>
				</el-pagination>
			</div>
		</div>
	</el-container>
</template>

<script>
	import { mapGetters } from "vuex";
	export default {
		name: "detailExamination",
		data() {
			return {
				/**
				 * 表单相关
				 */
				pickerTime: {}, // 时间选择临时储存
				form: {}, // 表单
				typeList: [
					{
						label: "待预约",
						value: "1",
					},
					{
						label: "预约成功",
						value: "2",
					},
					{
						label: "已到检",
						value: "3",
					},
					{
						label: "体检逾期",
						value: "4",
					},
					{
						label: "已出报告",
						value: "5",
					},
					{
						label: "已撤销",
						value: "6",
					},
				], // 状态选择 list
				orderStatusList: [
					{
						label: "待预约",
						value: "1",
					},
					{
						label: "已过期",
						value: "4",
					},
					{
						label: "已撤销",
						value: "6",
					},
				], // 状态选择值为0时，判断所需字段
				supplierList: [], // 供应商选择 list
				/**
				 * 表格相关
				 */
				// 页数相关信息
				loading: true,
				page: {
					pageSize: 10,
					pageNo: 1,
					total: 0,
				},
				tableData: [], // 表格数据
			};
		},
		computed: {
			...mapGetters(["authMap"]),
		},
		methods: {
			/**
			 * 获取供应商选择list
			 */
			async getSupplierList() {
				let res = await this.axios.get(this.getApiUrl("providerPage"), {
					params: {
						pageNo: 1,
						pageSize: 9999,
					},
				});
				this.supplierList = res?.data?.data || [];
			},
			async getData(resetPage) {
				if (resetPage === true) this.page.pageNo = 1;
				this.loading = true;
				let res = await this.axios.get(this.getApiUrl("userOrderPage"), {
					params: Object.assign(
						{
							userId: this.$route.query.userId,
						},
						this.form,
						this.page
					),
				});
				this.tableData = res?.data?.data || [];
				this.page.total = res?.data?.total || 0;
				this.loading = false;
			},
			/**
			 * 时间选择change
			 */
			toChangeTime(value, beginForm, endForm) {
				this.form[beginForm] = value ? value[0] : null;
				this.form[endForm] = value ? value[1] : null;
			},
		},
		filters: {
			/**
			 * 状态
			 */
			typeFilter(text, typeList) {
				let t = typeList.find((el) => el.value == text)?.label || text;
				return t;
			},
		},
		created() {
			// 面包导航
			this.$root.breadList = [
				{ name: "服务记录", link: "" },
				{ name: "体检服务记录", link: "" },
			];
		},
		mounted() {
			if (!this.authMap["sa_user_order_page"]) {
				this.loading = false;
				this.$message.error("抱歉，您暂无权限");
				return;
			}
			this.getSupplierList(); // 获取供应商选择list
			this.getData(); // 获取数据
		},
	};
</script>

<style type="text/scss" lang="scss" scoped>
	.detailExamination-box {
		.search-x {
			min-height: 120px;
			flex-shrink: 0;
		}
		.cont-x {
			flex: 1;
			flex-shrink: 0;
		}
	}
</style>